import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {USER_LOCALSTORAGE_KEY} from 'shared/const/localstorage';
import {PostProblemsResponse} from "../../../../types/problemsSchema";
import {problemsReceived} from "../../../../slice/groups/set-lessons/set-problems/setProblems";


interface PostProblemsParams {
    requestData?: {
        absence_of_students: boolean;
        technical_problems: boolean;
        late_cancellation: boolean;
        other: boolean;
        users_ids: number[];
        comment: string;
    };
    lessonsId: string | undefined;
}


export const fetchProblems = createAsyncThunk<PostProblemsResponse, PostProblemsParams>(
    'lessons/postProblems',
    async ({ requestData, lessonsId }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('Не найден токен в локальном хранилище.');
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.put<PostProblemsResponse>(
                `/api/lessons/${lessonsId}/problems`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            thunkAPI.dispatch(problemsReceived(response.data.problems));

            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue('error');
        }
    }
);
